import React, { Component } from 'react';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import { getApi } from '../App';

/* ===== Helpers de fecha ===== */

// dd/MM/yyyy -> YYYY-MM-DD
function dmyToYmd(s) {
  const m = String(s || '').trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return null;
  const [, dd, mm, yyyy] = m;
  return `${yyyy}-${mm}-${dd}`;
}

// Normaliza a 'YYYY-MM-DD' en horario LOCAL desde varios formatos
function normalizeFechaToYMD(fecha) {
  if (!fecha) return '';
  const s = String(fecha).trim();

  // 1) dd/MM/yyyy
  const asYMDfromDMY = dmyToYmd(s);
  if (asYMDfromDMY) return asYMDfromDMY;

  // 2) Ya YYYY-MM-DD
  const mYMD = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (mYMD) return `${mYMD[1]}-${mYMD[2]}-${mYMD[3]}`;

  // 3) ISO con offset sin ":" (+0000 / -0300) -> insertar ":"
  const withColonOffset = s.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');

  // 4) Parsear fecha-hora y llevar a local
  const d = new Date(withColonOffset);
  if (!isNaN(d)) {
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().slice(0, 10);
  }

  // 5) Extraer YYYY-MM-DD si está embebido
  const mInline = withColonOffset.match(/(\d{4}-\d{2}-\d{2})/);
  return mInline ? mInline[1] : '';
}

// 'YYYY-MM-DD' -> 'YYYY-MM-DDT00:00:00.000±HH:mm' (local)
function toLocalOffsetISO(dateStr) {
  if (!dateStr) return undefined;
  const offsetMin = -new Date().getTimezoneOffset();
  const sign = offsetMin >= 0 ? '+' : '-';
  const abs = Math.abs(offsetMin);
  const hh = String(Math.floor(abs / 60)).padStart(2, '0');
  const mm = String(abs % 60).padStart(2, '0');
  return `${dateStr}T00:00:00.000${sign}${hh}:${mm}`;
}

// Hoy en local 'YYYY-MM-DD'
function todayYMDLocal() {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 10);
}

// Toma fecha desde varias props posibles
function pickFechaProp(props) {
  return props.fecha ?? props.fechaHora ?? props.fechahora ?? '';
}

export class EditTramitesModal extends Component {
  constructor(props) {
    super(props);
    const fechaDesdeProps = normalizeFechaToYMD(pickFechaProp(props));

    this.state = {
      tipoTramites: [],
      snackbarOpen: false,
      snackbarmsg: '',
      // Fecha controlada
      fecha: fechaDesdeProps || todayYMDLocal(),
      idExpediente: props.idExpediente,
      tipoTramite: props.tipoTramite ?? 0,
      // Responsable controlado: acepta 'responsable' o 'resposable'
      responsable: props.responsable ?? props.resposable ?? ''
    };

    // binds
    this.snackbarClose = this.snackbarClose.bind(this);
    this.handleFechaChange = this.handleFechaChange.bind(this);
    this.handleTipoChange = this.handleTipoChange.bind(this);
    this.handleResponsableChange = this.handleResponsableChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    getApi()
      .getTipoTramites()
      .then((data) => this.setState({ tipoTramites: data || [] }));
  }

  componentDidUpdate(prevProps) {
    const openedNow = !prevProps.show && this.props.show;
    const changedItem =
      prevProps.identificador !== this.props.identificador ||
      prevProps.idExpediente !== this.props.idExpediente;

    const fechaChanged =
      pickFechaProp(prevProps) !== pickFechaProp(this.props);

    const responsableChanged =
      (prevProps.responsable ?? prevProps.resposable) !==
      (this.props.responsable ?? this.props.resposable);

    if (openedNow || changedItem || fechaChanged || responsableChanged) {
      const fechaDesdeProps = normalizeFechaToYMD(pickFechaProp(this.props));
      this.setState({
        fecha: fechaDesdeProps || todayYMDLocal(),
        tipoTramite: this.props.tipoTramite ?? 0,
        idExpediente: this.props.idExpediente,
        responsable: this.props.responsable ?? this.props.resposable ?? ''
      });
    }
  }

  snackbarClose() {
    this.setState({ snackbarOpen: false });
  }

  handleFechaChange(e) {
    this.setState({ fecha: e.target.value }); // YYYY-MM-DD
  }

  handleTipoChange(e) {
    this.setState({ tipoTramite: e.target.value });
  }

  handleResponsableChange(e) {
    this.setState({ responsable: e.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();

    const fechaISOConOffset = toLocalOffsetISO(this.state.fecha);

    const data = {
      id: event.target.identificador.value,
      idExpediente: this.props.idExpediente,
      tipoTramite: this.state.tipoTramite,
      // Enviar con offset local para evitar “día menos”
      fechaHora: fechaISOConOffset,
      // Si el backend espera solo fecha:
      // fechaHora: this.state.fecha,

      // ✅ CLAVE CORRECTA PARA EL BACKEND:
      responsable: this.state.responsable,

      observ: event.target.observ.value
    };

    getApi()
      .saveTramites(data)
      .then((res) => res.json())
      .catch((error) => console.error('Error:', error))
      .then((response) => {
        this.setState({
          snackbarOpen: true,
          snackbarmsg: 'El registro se guardó correctamente'
        });
        this.props.onClose();
      });
  }

  render() {
    const {
      fecha,
      tipoTramite,
      tipoTramites,
      responsable,
      snackbarOpen,
      snackbarmsg
    } = this.state;

    return (
      <div className="container">
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={this.snackbarClose}
          message={<span id="message-id">{snackbarmsg}</span>}
          action={[
            <IconButton
              key="close"
              arial-label="Cerrar"
              color="inherit"
              onClick={this.snackbarClose}
            >
              x
            </IconButton>
          ]}
        />
        <Modal
          key={this.props.identificador}
          {...this.props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained_modal_title_vcenter">
              Editar trámite {this.props.identificador} — Exp. {this.props.idExpediente}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={6}>
                <Form onSubmit={this.handleSubmit}>
                  <Form.Group controlId="identificador">
                    <Form.Label>Identificador:</Form.Label>
                    <Form.Control
                      type="number"
                      name="identificador"
                      defaultValue={this.props.identificador}
                      required
                      disabled
                    />
                  </Form.Group>

                  <Form.Group controlId="fecha">
                    <Form.Label>Fecha:</Form.Label>
                    <Form.Control
                      type="date"
                      name="fecha"
                      value={fecha || ''}
                      onChange={this.handleFechaChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group controlId="selectTipoTramite">
                    <Form.Label htmlFor="selectTipoTramite">Trámite</Form.Label>
                    <Form.Control
                      as="select"
                      id="selectTipoTramite"
                      value={tipoTramite}
                      onChange={this.handleTipoChange}
                    >
                      {tipoTramites.map((tp) => (
                        <option key={tp.identificador} value={tp.identificador}>
                          {tp.descrip}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>

                  <Form.Group controlId="responsable">
                    <Form.Label>Responsable:</Form.Label>
                    <Form.Control
                      type="text"
                      name="resposable"      
                      maxLength="100"
                      value={responsable}
                      onChange={this.handleResponsableChange}
                    />
                  </Form.Group>

                  <Form.Group controlId="observ">
                    <Form.Label>Observación:</Form.Label>
                    <Form.Control
                      type="text"
                      name="observ"
                      maxLength="100"
                      defaultValue={this.props.observ}
                    />
                  </Form.Group>

                  <Form.Group>
                    <Button variant="primary" type="submit">
                      Grabar
                    </Button>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={this.props.onHide}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditTramitesModal;
